module.exports = __webpack_public_path__ + "static/media/spinner.d059232c.svg";